"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function humanize(property = '') {
    return lodash_1.get(property.match(/[0-9]*__(.*)/), [1], property)
        .replace(/__/g, ' ')
        .replace(/_/g, ' ')
        .replace(/(\w+)/g, match => match.charAt(0).toUpperCase() + match.slice(1));
}
exports.default = humanize;
